<!-- eslint-disable no-unused-vars -->
<script setup>
import ActionBar from '@/components/schoolInstrument/component/detailInfo/actionBar.vue'
import CardForm from '@/components/common/card/cardForm.vue'
import appDialog from '@/components/schoolInstrument/mixins/AppDialog.vue'

import { getapprovingfilecontent } from '@/port/clientSide/oaExamine.js'
import { computed, defineProps, ref, defineEmits, defineExpose, onMounted, getCurrentInstance } from 'vue'
import { cloneDeep } from 'lodash'
import { dealFixQuery } from '@/components/schoolInstrument/component/mutual/common/config'
import { useDataList } from '@/hooks/useDataList'
import { useInside } from '@/hooks/useInside'

const props = defineProps({
  detailInfo: {
    type: Object,
    default: () => ({})
  },
  powerData: {
    type: Object,
    default: () => ({})
  },
  addConfig: {
    type: Object,
    default: () => ({})
  },
  isCollapseExpand: {
    type: Boolean,
    default: false
  },
  examineHeight: {
    type: Number,
    default: 0
  },
  currentData: {
    type: Object,
    default: () => ({})
  }
})

const emit = defineEmits(['change-status', 'change-data'])

const { handleListInfo, listInfo } = useDataList()
const { dealInside, dialogInfo, openInputValue, iIdValue, addInputShow } = useInside({}, emit)

const searchCriteria = ref({
  query: ''
})
const ruledata = ref({
  fixquery: {},
  fixorder: []
})

const screenSearch = {}
let isSearchStatus = false

const filterValueQuery = ref({})
const screenFixQuery = ref({})
const customStatusQuery = ref({})
const screenQuery = ref({})
const querys = ref({})
const searchText = ref('')
const searchCompQuery = ref({})

const noChangeScreenId = ref(-1)


onMounted(() => {
  if (props.detailInfo.dataList) {
    listInfo.value.list = props.detailInfo.dataList
  }
})


const screenChange = (e) => {
  let { value, condition, type, title, values, isSearch = true, filterValueObj = {}, id } = e
  if (filterValueObj && JSON.stringify(filterValueObj) !== '{}') {
    filterValueQuery.value = { ...filterValueQuery.value, ...filterValueObj }
  }
  if (condition) {
    // 处理需要条件的
    if (condition.val !== 'between' && type === 'number') {
      value = value[0]
    }

    if (type === 'timeof') {
      type = 'date'
    }
    // 由于 申请人和申请时间 要走fixquery
    const typeName = {
      appuser: '申请人',
      date: '提交时间'
    }
    const submitName = `${typeName[title] || title}_${type}`
    const obj = {
      title,
      type,
      submitName,
      conditionName: condition.name,
      condition: condition.val,
      conditionValue: value
    }
    const data = {
      linked: [obj]
    }
    const fixquery = dealFixQuery(data, props.customParams, props.customDeskId)
    delete fixquery.ov
    // 筛选组件中需要走 fixquery的参数
    if (fixquery[submitName]) {
      screenFixQuery.value = {
        ...screenFixQuery.value,
        ...fixquery
      }
    }
  } else {
    const _type = `${title}_${type}`
    if (title === 'status') {
      if (typeof value[0] === 'object') {
        const defaultStatus = value.filter(c => c.step === undefined).map(c => c.status)
        const customStatus = value.filter(c => c.step !== undefined).map(c => ({ value: c.step, status: c.status }))
        value = defaultStatus
        customStatusQuery.value.step = cloneDeep(customStatus)
      } else {
        const valObj = {
          已通过: '1',
          待审批: '0',
          未通过: '2',
          已撤回: '3',
          进行中: '0',
        }
        value = value.map(item => valObj[item])
        customStatusQuery.value = {
          step: []
        }
      }
    }
    const obj = {
      [_type]: value
    }
    if (values && JSON.stringify(values) !== '[]') {
      screenQuery.value = {
        ...screenQuery.value,
        ...obj
      }
    } else {
      delete screenQuery.value[_type]
      delete querys.value[_type]
    }
  }
  screenSearch[id] = true
  if (screenNum.value === Object.keys(screenSearch).length) {
    // 当筛选组件的数量 和 screenSearch中的 长度一样 就可以请求接口了  否则会请求多次
    const screenFixQueryValue = cloneDeep(screenFixQuery.value)
    for (const key in screenFixQueryValue) {
      const query = screenFixQueryValue[key].value
      if (!isSearch) {
        delete screenFixQueryValue[key]
        if (ruledata.value.fixquery && ruledata.value.fixquery[key]) {
          delete ruledata.value.fixquery[key]
        }
        continue
      }
      if (key.includes('relation-user')) {
        // 单独联系人控件
        if (query.length === 1 && (query[0] === '' || query[0] === null || query[0] === undefined)) {
          delete screenFixQueryValue[key]
          if (ruledata.value.fixquery && ruledata.value.fixquery[key]) {
            delete ruledata.value.fixquery[key]
          }
        } else if (query.length === 0) {
          delete screenFixQueryValue[key]
          if (ruledata.value.fixquery && ruledata.value.fixquery[key]) {
            delete ruledata.value.fixquery[key]
          }
        }
      }
    }
    ruledata.value.fixquery = cloneDeep({
      ov: 'and',
      ...ruledata.value.fixquery,
      ...screenFixQuery
    })

    querys.value = {
      ...querys.value,
      ...screenQuery.value,
      ...filterValueQuery.value
    }
    for (const key in querys.value) {
      const query = querys.value[key]
      if (!isSearch) {
        delete querys.value[key]
        continue
      }
      if (query.length === 1 && (query[0] === '' || query[0] === null || query[0] === undefined)) {
        delete querys.value[key]
      } else if (query.length === 0) {
        delete querys.value[key]
      }
    }
    getList()
  }
}

const todoInside = async ({ row, insideInfo }) => {
  // 遍历查询是否有配置“数据解析”字段，如果有配的话需要调接口获取解析的值
  if (Object.prototype.hasOwnProperty.call(row, 'transfile') && row.transfile && insideInfo.linked && insideInfo.linked.length > 0) {
    const linkedFields = insideInfo.linked;
    let shouldDealInside = true; // 标记是否需要执行 dealInside
    for (const linkedField of linkedFields) {
      const valueKey = `${linkedField.title}_${linkedField.type}`;
      if (valueKey === 'data-analysis_text') {
        const obj = {
          approvalId: props.detailInfo.applyInfo.id || props.detailInfo.applyInfo.approvalId,
          approvingId: row.approvingId
        }
        const res = await getapprovingfilecontent(obj)
        if (res.code === 0) {
          row['data-analysis'] = res.data
          dealInside(row, insideInfo);
          shouldDealInside = false;
        }
        break;
      }
    }
    if (shouldDealInside) {
      dealInside(row, insideInfo);
    }
  }
  else {
    dealInside(row, insideInfo)
  }
}


const customScene = (val) => {
  const { url, query, open, popUps } = val
  const obj = {
    2: 'dialog',
    3: 'new',
    4: 'old',
    5: 'rightdia'
  }
  dialogInfo.value = {
    isVisible: true,
    dialogName: query.name,
    dialogWidth: popUps.w + 'px',
    dialogHeight: popUps.h + 'px',
    openType: obj[open],
    dialogUrl: url,
    customSize: popUps.customSize,
    diaSize: popUps.diaSize,
  }
}

const editUserInfo = (info, row) => {

}

const getList = async () => {
  const obj = {
    pageId: props.detailInfo.pageId,
    key: '',
    ...props.detailInfo.totalParams,
    query: querys.value,
  }
  if (isSearchStatus) {
    obj.key = searchText.value
    obj.query = {
      ...obj.query,
      ...searchCompQuery.value
    }
  }

  if (ruledata.value.fixorder && obj.fixorder) {
    obj.fixorder = [...obj.fixorder, ...ruledata.value.fixorder]
  }
  if (ruledata.value.fixquery && obj.fixquery) {
    obj.fixquery = {
      ...obj.fixquery,
      ...ruledata.value.fixquery,
    }
  }
  obj.currentPage = props.detailInfo.listInfo.currentPage
  obj.pageSize = props.detailInfo.listInfo.tablePageSize
  obj.id = props.detailInfo.applyInfo.id
  obj.powerData = props.detailInfo.powerData
  await handleListInfo(obj)
  emit('change-data', listInfo.value.list)
}


const getKey = (item) => {
  const id = item.activeId
  if (id) {
    return id
  } else {
    return 'info'
  }
}

const handeSearch = (value) => {
  if (typeof value === 'object') {
    searchText.value = ''
    searchCompQuery.value = value
  } else {
    searchText.value = value
    searchCompQuery.value = {}
  }
  if (value === '') isSearchStatus = false
  if (value) isSearchStatus = true
  getList()
}

const openAppDialog = (val) => {
  console.log(val, 'valvalval')
  dialogInfo.value = val
}


const diaClose = () => {
  openInputValue.value = {}
  iIdValue.value = -1
  addInputShow.value = false
  getList()
}

const cardClick = (item) => {
  emit('card-click', item)
}

const toColExpand = () => {
  emit('change-status', !props.isCollapseExpand)
}

const animationend = () => {
  console.log(12312321)
}

const isSetCard = computed(() => {
  return props.detailInfo.cardInfo && Object.keys(props.detailInfo.cardInfo).length > 0
})


const screenNum = computed(() => {
  let screenArr = []
  const list = props.detailInfo.toolInfo
  list.forEach(item => {
    if (Array.isArray(item.info)) {
      const key = getKey(item)
      const arr = item[key].filter(f => f.type === 'screen' && f.checkName)
      screenArr.push(...arr)
    }
  })
  return screenArr.length
})


defineExpose({
  listInfo
})

</script>

<template>
  <div class="data-nav" @animationend="animationend"
    :style="{ width: isCollapseExpand ? detailInfo.width + 'px' : '0px' }">
    <div class="data-nav-tools">
      <ActionBar @screenChange="screenChange" @handeSearch="handeSearch" @open-appDialog="openAppDialog"
        @openAppInitiate="openAppInitiate" @change-screen-id="noChangeScreenId = $event"
        :noChangeScreenId="noChangeScreenId" :addConfig="addConfig" :listData="detailInfo.dataList" :ruledata="ruledata"
        :powerData="powerData" :isLeft="false" :searchCriteria="searchCriteria" :todoList="detailInfo.toolInfo" />
    </div>
    <div class="data-nav-card" :style="{ padding: isCollapseExpand ? '0 12px' : '0' }">
      <template v-if="isSetCard">
        <div class="data-nav-card-item" @click="cardClick(item)" v-for="item in listInfo.list" :key="item.approvingId"
          :class="currentData && item.approvingId === currentData.approvingId ? 'data-nav-card-active' : ''">
          <CardForm @openAppInitiate="openAppInitiate" @open-appDialog="openAppDialog" @custom-scene="customScene"
            @edit-user-info="editUserInfo" @todo-inside="todoInside" :data="item" :cardConfig="detailInfo.cardInfo" />
        </div>
      </template>
      <template v-else>
        <div class="data-nav-card-nodata">
          请配置卡片信息
        </div>
      </template>
    </div>
    <div class="data-nav-col" @click="toColExpand" v-if="examineHeight">
      <el-icon>
        <template v-if="isCollapseExpand">
          <ArrowLeft />
        </template>
        <template v-else>
          <ArrowRight />
        </template>
      </el-icon>
    </div>
    <app-dialog :dialogInfo="dialogInfo" :iId="iIdValue" :appId="appId" v-model:isDetail="openInputValue.isDetail"
      v-model:addInputShow="addInputShow" :coverVal="openInputValue.search" :datatype="openInputValue.datatype"
      :openfunction="openfunctionValue" @close="diaClose"></app-dialog>
  </div>
</template>

<style scoped lang='scss'>
.data-nav {
  display: flex;
  flex-direction: column;
  position: relative;
  border-right: solid 1px #DFDFDF;
  transition: .3s;
  height: 100%;
  box-sizing: border-box;

  &-tools {
    min-height: 40px;
  }

  &-card {
    width: 100%;
    flex: 1;
    position: relative;
    padding: 0 12px;
    box-sizing: border-box;
    overflow: auto;
    display: flex;
    flex-direction: column;
    background-color: #fff;

    &-nodata {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #666666;
      font-weight: 400;
      font-size: 14px;
    }

    &-item {
      width: 100%;
      margin-bottom: 12px;
      cursor: pointer;
      box-sizing: border-box;

      .card-form-box {
        border-radius: 4px;
        border: solid 1px transparent;
      }

      &:last-child {
        margin-bottom: 0px;
      }
    }

    ::v-deep &-active {
      .card-form-box {
        border: solid 1px #4e86ff;
      }
    }
  }

  &-col {
    position: absolute;
    right: -23px;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 14px;
    height: 56px;
    border-radius: 0px 19px 19px 0px;
    box-shadow: 0px 0px 15.6px 0px rgba(0, 0, 0, 0.1);
    background-color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 2;
  }
}
</style>
